import { richTextFields } from '@/data/sanity/fragments/_shared'
import cmsSettings from '../cmsSettings'
import { link } from '@/data/sanity/fragments'

export const fields = `
  _type,
  _id,
  ${cmsSettings()},
  title,
  description[]{${richTextFields}},
  items[]{
    title,
    "id": id.current,
    smallDescription[]{${richTextFields}},
    largeDescription[]{${richTextFields}},
    ${link.fragment('link')}
  }
`

export const fragment = (name = 'titleAndAccordion') => `${name}{ ${fields} }`

const exported = {
  fields,
  fragment,
}

export default exported
